const breakpoints = {
    sm: '576px',
    smmd: '650px',
    md: '768px',
    mdlg: '850px',
    lg: '992px',
    xl: '1200px',
    xxl: '1400px',
    xxxl: '1600px',
    xxxxl: '1800px',
    xxxxxl: '2000px',
    xxxxxxl: '2200px',
    ultraWide: '3000px',
}

export default breakpoints